<template>
    <div>
        <div style="width: 1200px;margin: 0 auto;" class="crumbs">
            <span style="cursor: pointer;" @click="Jump({path:'/'})">{{$t('view.首页')}}</span><span style="margin: 0 5px">></span>
            <span style="cursor: pointer;" @click="Jump({path:'/showList',query:{biddingType:$route.query.biddingType}})">{{  $route.query.biddingType==1?$t('view.询价'):$t('view.招标')}}</span>
            <span v-if="$route.query.projectType">
                <span style="margin: 0 5px;color: #333333;">></span><span style="cursor: pointer;">{{getStatus('sys_section_type',$route.query.projectType)}}</span>
            </span>
        </div>
        <div style="background: #fff;">
            <div style="padding-top: 20px;">
                <ItemList ref="ItemList"></ItemList>
            </div>
        </div>
    </div>
  </template>
    
  <script>
  import ItemList from '@/components/ItemList.vue'
  import {homeListPage} from '@/api/index'
  import {getDicts} from '@/api/index'
  export default {
    components: { ItemList },
    data(){
      return{
        pageNum:1,
        locale: localStorage.getItem('locale')||'zh',
        sys_section_type:[]
      }
    },
    created(){
      this.homeListPage()
      this.getDicts('sys_section_type')
    },  
    methods:{
        Jump(url){
            if(url.path=='/showList'){
                this.$router.replace(url);
                this.homeListPage()
            }else{
                this.$router.push(url)
            }
        },
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },  
        //数据列表
        homeListPage(pageNum){
            homeListPage({
                pageSize:10,
                pageNum:pageNum||this.pageNum,
                biddingType:this.$route.query.biddingType,
                projectType:this.$route.query.projectType,
                searchValue:'',
                sectionStautsList:'1,7,8'
            }).then(res=>{
                this.$refs.ItemList.tableData=res.rows
                this.$refs.ItemList.total=res.total
                this.$refs.ItemList.Loading=res.total?false:true

            })
        },  
    }
  };
  </script>
<style lang="scss" scoped>
.crumbs{
    font-size: 16px;
    line-height: 35px;
    span{
        color: #999999;
    }
}
</style>
   